import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

// Browser Supabase client. Session lives in localStorage by default (persisted +
// auto-refreshed). PKCE + detectSessionInUrl is the correct web default so magic
// links / OAuth redirects (a future addition) resolve; it's harmless for the
// email+password flow used now.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "pkce",
  },
});
